import { NgModule } from '@angular/core';
import { AddressOverrideConfirmDialogComponent } from './address-override-confirm-dialog.component';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    AddressOverrideConfirmDialogComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
    MatButtonModule,
  ],
  exports: [
    AddressOverrideConfirmDialogComponent,
  ],
})
export class AddressOverrideConfirmDialogModule {
}
